/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForTemplateAzureProvider extends models.ScheduleExecutionParameterForTemplateBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForTemplateAzureProvider");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForTemplateAzureProvider.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForTemplateAzureProvider>): ScheduleExecutionParameterForTemplateAzureProvider {
        let obj = Object.assign(new ScheduleExecutionParameterForTemplateAzureProvider(), model);
        ScheduleExecutionParameterForTemplateAzureProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForTemplateAzureProvider>): ScheduleExecutionParameterForTemplateAzureProvider {
        if (!model) return null;
        return ScheduleExecutionParameterForTemplateAzureProvider.newInstance(<ScheduleExecutionParameterForTemplateAzureProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForTemplateAzureProvider) {
        if (!obj) return;

        models.ScheduleExecutionParameterForTemplateAzureProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForTemplateAzureProvider): boolean {
        if (models.ScheduleExecutionParameterForTemplateBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForTemplateAzureProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource group for which you need to execute the template for.
     */
    resource_group: string;

    /**
     * Location under which you need to execute the template for.
     */
    location: string;

}
